import { useRef, useEffect } from "react";
import { createRoot } from "react-dom/client";

const PricingShadowWrapper = ({ children }) => {
  const hostRef = useRef(null);

  useEffect(() => {
    const shadowHost = hostRef.current;
    if (shadowHost.shadowRoot) return;

    if (!shadowHost.shadowRoot) {
      const shadowRoot = shadowHost.attachShadow({ mode: "open" });

      const container = document.createElement("div");
      shadowRoot.appendChild(container);

     // Fetch and inject CSS
     fetch('/price-page-css/styles.css')
     .then(res => res.text())
     .then(css => {
        const styleEl = document.createElement('style');

        // Adjust font URLs if necessary:
        //const adjusted = css.replace(
        //  /url\(["']?(?:\.\/)?fonts\//g,
        //  `url(${window.location.origin}/price-page-css/fonts/`
        //);

        //let start = adjusted.indexOf("@font-face");
        //let end = adjusted.indexOf("}",start);
        //console.log(adjusted.substring(start,end));

        const adjusted = css;

        styleEl.textContent = adjusted;
        shadowRoot.appendChild(styleEl);
     })
     .catch(err => console.error('Error loading CSS:', err));

     // Render children into shadow root
     const root = createRoot(container);
     root.render(children);
    }
  }, [children]);

  return <div ref={hostRef}></div>;
};

export default PricingShadowWrapper;
